// extracted by mini-css-extract-plugin
export var arrowWrapper = "styles-module--arrowWrapper--eaa77";
export var blog_description = "styles-module--blog_description--1c66c";
export var blog_tags = "styles-module--blog_tags--0b90b";
export var blog_thumb_wrapper = "styles-module--blog_thumb_wrapper--624c0";
export var blog_title = "styles-module--blog_title--382db";
export var image = "styles-module--image--6b047";
export var product_update_wrapper = "styles-module--product_update_wrapper--fe85f";
export var text = "styles-module--text--f4952";